import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { gsap } from 'gsap';

export default () => {
  Swiper.use([Autoplay, Navigation, Pagination]);
  const DEFAULT_INTERVAL = 10000;
  const DEFAULT_SPEED = 1000;
  const rgbToHex = (r, g, b) =>
    '#' +
    [r, g, b]
      .map((x) => {
        const hex = x.toString(16);
        return hex.length === 1 ? '0' + hex : hex;
      })
      .join('');

  function Timer(fn, t) {
    var timerObj = setInterval(fn, t);

    this.stop = function () {
      if (timerObj) {
        clearInterval(timerObj);
        timerObj = null;
      }
      return this;
    };

    // start timer using current settings (if it's not already running)
    this.start = function () {
      if (!timerObj) {
        this.stop();
        timerObj = setInterval(fn, t);
      }
      return this;
    };

    // start with new or original interval, stop current interval
    this.reset = function (newT = t) {
      t = newT;
      return this.stop().start();
    };
  }

  class Slider {
    constructor(sliderContainer) {
      this.sliderContainer = sliderContainer;
      this.bannerSliders = sliderContainer.querySelectorAll(
        `.swiper .swiper-slide`
      );
      this.bannerSliderPagination =
        sliderContainer.querySelectorAll(`.swiper-pagination`)[0];
      this.swiper = sliderContainer.querySelectorAll(`.swiper`)[0];
      this.bannerSliderNav = sliderContainer.querySelectorAll(`.navigation`)[0];
      // this.nextButton = sliderContainer.querySelectorAll(`.btn--arrow--right`)[0];
      this.sliderInterval;
      this.bannerSlider;
      this.loaded = false;
      this.imagesLoaded = 0;
      this.bannerSliderIndex = 0;
      var _instance = this;

      if (this.bannerSlider === undefined && this.bannerSliders.length > 0) {
        this.bannerSlider = new Swiper(this.swiper, {
          spaceBetween: 0,
          slidesPerView: 1,
          loop: false,
          allowTouchMove: false,
          centeredSlides: true,
          autoplay: {
            delay: DEFAULT_INTERVAL,
            disableOnInteraction: false,
          },
          disableOnInteraction: false,
          pagination: {
            el: this.bannerSliderPagination,
            clickable: true,
            renderBullet: function (index, className) {
              return (
                '<span class="p bold ' +
                className +
                '">' +
                (index + 1) +
                '</span>'
              );
            },
          },
          on: {
            slideChange: function (swiper) {
              if (_instance.bannerSliders.length > 1) {
                let lastSlide = swiper.slides[swiper.previousIndex];
                _instance.bannerSliderIndex = swiper.activeIndex;
                if (_instance.sliderInterval !== undefined)
                  _instance.sliderInterval.reset(DEFAULT_INTERVAL);
                if (lastSlide !== undefined) {
                  lastSlide.classList.add('swiper-slide-old');
                  setTimeout(function () {
                    lastSlide.classList.remove('swiper-slide-old');
                  }, 1500);
                }
              }
              let text =
                _instance.bannerSliders[swiper.activeIndex].querySelectorAll(
                  '.text-container'
                )[0];
              if (text !== null && text !== undefined) {
                if (swiper.previousIndex < swiper.activeIndex) {
                  text.classList.remove('inverted');
                } else {
                  text.classList.add('inverted');
                }
                gsap.fromTo(
                  text,
                  { '--clip': '0%', '--clip2': '0%' },
                  {
                    duration: 1.5,
                    '--clip': '180%',
                    '--clip2': '120%',
                    ease: 'power4.inOut',
                    overwrite: 'auto',
                    onComplete: function () {},
                  }
                );
              }
            },
          },
        });

        Array.prototype.forEach.call(
          this.bannerSliders,
          function (item, index) {
            // if(index === 0) {
            let image = item.querySelectorAll(`img`)[0];

            if (_instance.bannerSliders.length == 1) {
              _instance.swiper.classList.remove('loading');
            }

            if (image !== undefined && image.complete) {
              _instance.imagesLoaded++;
              item.classList.add('loaded');
              _instance.swiper.classList.remove('loading');
              if (_instance.imagesLoaded == _instance.bannerSliders.length) {
                _instance.loaded = true;
                _instance.swiper.classList.remove('loading');
              }
            } else {
              if (image !== undefined) {
                image.addEventListener('load', function () {
                  _instance.imagesLoaded++;
                  item.classList.add('loaded');
                  _instance.swiper.classList.remove('loading');
                  if (
                    _instance.imagesLoaded == _instance.bannerSliders.length
                  ) {
                    _instance.loaded = true;
                    _instance.swiper.classList.remove('loading');
                  }
                });
                image.onload = function () {
                  _instance.imagesLoaded++;
                  item.classList.add('loaded');
                  _instance.swiper.classList.remove('loading');
                  if (
                    _instance.imagesLoaded == _instance.bannerSliders.length
                  ) {
                    _instance.loaded = true;
                    _instance.swiper.classList.remove('loading');
                  }
                };
              }
            }
            _instance.swiper.classList.remove('loading');
          }
        );

        this.sliderInterval = new Timer(function () {
          _instance.swiper.classList.remove('loading');
          // if (_instance.loaded) {
          if (
            _instance.bannerSliderIndex ===
            _instance.bannerSliders.length - 1
          ) {
            _instance.bannerSliderIndex = 0;
            _instance.bannerSlider.slideTo(0, DEFAULT_SPEED);
          } else {
            _instance.bannerSliderIndex += 1;
            _instance.bannerSlider.slideNext(DEFAULT_SPEED);
          }
          // }
        }, DEFAULT_INTERVAL);

        let text =
          _instance.bannerSliders[0].querySelectorAll('.text-container')[0];
        if (text !== null) {
          gsap.fromTo(
            text,
            { '--clip': '0%', '--clip2': '0%' },
            {
              duration: 1.5,
              '--clip': '100%',
              '--clip2': '120%',
              ease: 'power4.inOut',
              overwrite: 'auto',
              onComplete: function () {},
            }
          );
        }
      }
    }
  }

  let createSlider = function () {
    let sliders = document.querySelectorAll('.module--heroBanner');
    let imageSliders = document.querySelectorAll('.module--imageCarousel');
    sliders = mergeArrays(sliders, imageSliders);

    Array.prototype.forEach.call(sliders, function (item, index) {
      let tempSlider = new Slider(item, DEFAULT_INTERVAL);
    });
  };

  let mergeArrays = function (...arrays) {
    let mergedArray = [];
    arrays.forEach((array) => {
      mergedArray.push(...array);
    });
    return mergedArray;
  };

  window.addEventListener('resize', function () {
    // createSlider();
  });

  createSlider();
};
